import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../../shared/services/permission.service';
import { ADMIN, PERMISSION_ID, USER_DATA } from '../utils/constant';

export const permissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const userData = JSON.parse(localStorage.getItem(USER_DATA) || '{}');

  if (userData.role === ADMIN) {
    return true;
  }

  const permissionId = route.data?.[PERMISSION_ID] as string;

  if (!permissionId) {
    return true;
  }

  if (permissionService.hasAccess(permissionId)) {
    return true;
  }

  router.navigate(['/dashboard/unauthorized'], { replaceUrl: true });
  return false;
};
